import "./PolicyPages.css"

export default function ShippingDelivery() {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Shipping and Delivery Policy</h1>
        <p className="last-updated">Last Updated: April 7, 2025</p>

        <section className="policy-section">
          <h2>1. Shipping Information</h2>
          <p>
            We are committed to delivering your orders promptly and securely. Please review our shipping policy below:
          </p>
          <ul>
            <li>
              <strong>Processing Time:</strong> Orders are typically processed within 1-2 business days after payment
              confirmation.
            </li>
            <li>
              <strong>Shipping Methods:</strong> We offer standard and express shipping options for your convenience.
            </li>
            <li>
              <strong>Shipping Partners:</strong> We work with reputable shipping carriers to ensure safe delivery of
              your items.
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>2. Delivery Timeframes</h2>
          <p>Estimated delivery times:</p>
          <ul>
            <li>
              <strong>Standard Shipping:</strong> 3-5 business days
            </li>
            <li>
              <strong>Express Shipping:</strong> 1-2 business days
            </li>
            <li>
              <strong>International Shipping:</strong> 7-14 business days (subject to customs clearance)
            </li>
          </ul>
          <p>
            Please note that these are estimated timeframes and actual delivery times may vary based on your location
            and other factors.
          </p>
        </section>

        <section className="policy-section">
          <h2>3. Shipping Costs</h2>
          <p>Shipping costs are calculated based on:</p>
          <ul>
            <li>Destination address</li>
            <li>Weight and dimensions of the package</li>
            <li>Selected shipping method</li>
          </ul>
          <p>The exact shipping cost will be displayed during checkout before you complete your purchase.</p>
        </section>

        <section className="policy-section">
          <h2>4. Free Shipping</h2>
          <p>
            We offer free standard shipping on orders over $50 for domestic deliveries. International orders and express
            shipping options are not eligible for free shipping unless specified in a promotional offer.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Order Tracking</h2>
          <p>
            Once your order is shipped, you will receive a confirmation email with a tracking number. You can track your
            package by:
          </p>
          <ul>
            <li>Visiting our Order Tracking page and entering your tracking number</li>
            <li>Clicking the tracking link in your shipping confirmation email</li>
            <li>Contacting our customer service team with your order number</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. International Shipping</h2>
          <p>For international orders:</p>
          <ul>
            <li>Customs duties, taxes, and import fees are the responsibility of the recipient</li>
            <li>Delivery times may be extended due to customs clearance procedures</li>
            <li>Some products may not be available for international shipping due to regulations</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>7. Delivery Issues</h2>
          <p>In case of delivery issues:</p>
          <ul>
            <li>
              <strong>Lost Packages:</strong> If your package is lost during transit, please contact us within 7 days of
              the expected delivery date.
            </li>
            <li>
              <strong>Damaged Packages:</strong> If your package arrives damaged, please take photos and contact us
              within 48 hours of delivery.
            </li>
            <li>
              <strong>Incorrect Address:</strong> Additional shipping charges may apply if a package is returned due to
              an incorrect address provided by the customer.
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>8. Contact Us</h2>
          <p>If you have any questions about our Shipping and Delivery Policy, please contact us at:</p>
          <p>
            Email: shipping@example.com
            <br />
            Phone: (123) 456-7890
          </p>
        </section>
      </div>
    </div>
  )
}

